import React from 'react';
import styled from 'styled-components';

import { device } from '../../Constants/MediaQueries';

export const CardHeader = styled.div`
    margin-bottom: 2rem;
`;